import { CreateInstanceStruct, Instance } from './../../model/instance';
import { UrlMaker } from 'src/app/commons/url-maker';
import { Injectable } from '@angular/core';
import { OperationResult } from '@tb/auth';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { WorkFlowService } from './work-flow.service';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class InstancesService {
    storeApiUrl: string;
    constructor(private workflow: WorkFlowService, private http: HttpClient) {
        this.storeApiUrl = environment.settings.storeApiUrl;
    }

    public getInstancesByPartnerCode(partnerCode: string): Observable<OperationResult> {
        //subkey needed to know which mdm call
        if (partnerCode === undefined) {
            return throwError('PartnerCode is missing!');
        }

        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('instancesbypartnercode')
            .appendSegment(partnerCode)
            .appendSegment('true')
            .toString();

        return this.http
            .get<OperationResult>(url, { headers: headers })
            .pipe(catchError((error: any) => throwError(error || 'server error (getExportList)')));
    }

    public async createInstanceOnPrem(instance: Instance): Promise<OperationResult> {
        //subkey needed to know which mdm call
        let instanceOnPrem: CreateInstanceStruct = new CreateInstanceStruct();
        instanceOnPrem.instanceKey = instance.InstanceKey;
        instanceOnPrem.description = instance.Description;
        instanceOnPrem.domainId = '';
        //instanceOnPrem.frontendurl = instance.FrontEndUrl;
        instanceOnPrem.origin = 'ONPREM';
        instanceOnPrem.partnerCode = instance.PartnerCode;
        instanceOnPrem.accountName = instance.CreatorAccountUserName;

        const bodyString = JSON.stringify(instanceOnPrem);
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker().appendBaseUrl(this.storeApiUrl).appendSegment('instances').appendSegment('createonprem').toString();

        return this.http.post<OperationResult>(url, bodyString, { headers: headers }).toPromise();
    }

    public async modifyInstanceOnPrem(instance: Instance, accountDoingAction: string): Promise<OperationResult> {
        //subkey needed to know which mdm call
        const bodyString = JSON.stringify(instance);
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('instances')
            .appendSegment('updateonprem')
            .appendSegment(accountDoingAction)
            .toString();

        return this.http.post<OperationResult>(url, bodyString, { headers: headers }).toPromise();
    }

    public getInstanceOnPrem(instanceKey: string): Observable<OperationResult> {
        //subkey needed to know which mdm call
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('instances')
            .appendSegment('getonprem')
            .appendSegment(instanceKey)
            .toString();

        return this.http.get<OperationResult>(url, { headers: headers });
    }

    public getInstancesbytags(tags: string, accountNameForOnPremFilter?: string): Observable<OperationResult> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const url = new UrlMaker()
            .appendBaseUrl(this.storeApiUrl)
            .appendSegment('instancesbytags')
            .appendSegment(tags)
            .appendSegment(accountNameForOnPremFilter)
            .toString();

        return this.http.get<OperationResult>(url, { headers: headers });
    }
}
